/**
 * Inside an AuthRoute, dispatch isHelping so that it can be used at the Root level for an alert banner.
 */
import { useContext, useEffect } from 'react'
import { useIsHelping } from '@fs/zion-user'
import { useTranslation } from 'react-i18next'
import AlertBannerContext from '../../context/AlertBannerContext'

export default function IsHelpingDispatcher({ children }) {
  const isHelping = useIsHelping()
  const { t } = useTranslation()
  const { setAlertBannerProps, setOpen } = useContext(AlertBannerContext)

  useEffect(() => {
    if (isHelping) {
      setOpen(isHelping)
      setAlertBannerProps({
        type: 'error',
        message: t('helper-mode-no-access.feedback', 'Access to Settings is not available while helping others.'),
        dismissText: t('common-ui:close.action', 'Close'),
      })
    }
  }, [setAlertBannerProps, setOpen, isHelping, t])
  if (isHelping) {
    return null
  }
  return children
}
